import { useCreateEvent } from '@/features/events/hooks/useCreateEvent';
import { EventType as NewEventType } from '@/features/events/types/EventType';
import { saveEvent } from '@/utils/apis/user-service';
import { useAuthStore } from '@/utils/stores/useAuthStore';
import { useUserStore } from '@/utils/stores/useUserStore';

interface CloseDialogProps {
    onDismissClick: () => void;
    onConfirmClick: () => void;
}

export const CloseDialog: React.FC<CloseDialogProps> = ({
    onDismissClick,
    onConfirmClick,
}) => {
    const { sendEvent } = useCreateEvent();
    const { auth } = useAuthStore();
    const { userData } = useUserStore();

    const onDismissButtonClicked = async () => {
        onDismissClick();
        if (!auth.idToken || !userData.email) return;

        await saveEvent(
            userData.email,
            "dismiss_exit_popup_button_clicked",
            () => {},
            (error) => console.log(error),
            "health_assessment_questions_page"
        );

        await sendEvent({
            event: NewEventType.BUTTON_CLICK,
            sub_category: "dismiss_button",
            event_metadata: { action: "dismiss_close_health_assessment_dialog" }
        });
    };

    const onConfirmButtonClicked = async () => {
        onConfirmClick();
        if (!userData.email) return;

        await saveEvent(
            userData.email,
            "confirm_exit_popup_button_clicked",
            () => {},
            (error) => console.log(error),
            "health_assessment_questions_page"
        );

        await sendEvent({
            event: NewEventType.BUTTON_CLICK,
            sub_category: "action_button",
            event_metadata: { action: "confirm_close_health_assessment_dialog" }
        });
    };

    return (
        <div className="w-[90%] h-[329px] rounded-[15px] bg-white shadow-platform absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
            <div className="w-[90%] h-[90%] flex flex-col justify-between">
                <div className="font-bold text-[20px] leading-[25px]">
                    Manca poco!<br />Completa il questionario
                </div>
                <div className="font-normal text-[16px] leading-[26px]">
                    Uscendo <strong>perderai le risposte</strong> date finora 😓.
                    Manca davvero poco per concludere il tuo questionario e salvare tutte le risposte!
                </div>
                <div className="w-full h-[120px] flex flex-col justify-between">
                    <button
                        className="w-full h-[50px] rounded-[5px] bg-white border border-solid border-holifya-blue cursor-pointer uppercase font-bold text-[16px] leading-[22px] text-holifya-blue"
                        onClick={onConfirmButtonClicked}
                    >
                        Completa questionario
                    </button>
                    <button
                        className="w-full h-[50px] rounded-[5px] bg-white cursor-pointer font-bold text-[16px] leading-[22px] text-black"
                        onClick={onDismissButtonClicked}
                    >
                        Chiudi
                    </button>
                </div>
            </div>
        </div>
    );
}; 